import { MapBrowserEvent } from "ol";
import BaseEvent from "ol/events/Event";
import EventType from "ol/events/EventType";
import EventRememberingPointerInteraction from "./EventRememberingPointerInteraction";
import { TrackEntity } from "./TrackEntity";
import TrackLineFeature from "./TrackLineFeature";

export class SelectTrackEvent extends BaseEvent {
    static EventType = 'selecttrack'
    track: TrackEntity
    constructor(track: TrackEntity) {
        super(SelectTrackEvent.EventType)
        this.track = track
    }
}

export default class SelectTrack extends EventRememberingPointerInteraction {
    handleEvent(event: MapBrowserEvent<any>): boolean {
        
        if (event.originalEvent.type === EventType.CONTEXTMENU) {
            // Avoid context menu for long taps when drawing on mobile
            event.preventDefault();
        }

        if(event.type === 'singleclick') {
            return this.handleSingleClick(event)
        }
        return super.handleEvent(event)
    }
    handleSingleClick(event: MapBrowserEvent<any>) {
        const featuresAtPixel = event.map.getFeaturesAtPixel(event.pixel)
        const trackLineFeaturesAtPixel = featuresAtPixel.filter(f => f instanceof TrackLineFeature) as TrackLineFeature[]
        if(trackLineFeaturesAtPixel.length === 1) {
            this.dispatchEvent(new SelectTrackEvent(trackLineFeaturesAtPixel[0].track))
            return false
        }
        return true
    }
}